// import React, { useState } from 'react'

const addressRegex = new RegExp(/DOMIC[A-Za-zÀ-ÖØ-öø-ÿ]+(\n.+){3}/)
const dobRegex = new RegExp(/([0-9]{2}\/){2}[0-9]{4}/)
const zipcodeRegex = new RegExp(/\d{5}/)
const colonyRegex = new RegExp(/^COL [A-Za-zÀ-ÖØ-öø-ÿ ]+ \d{5}/)
const namesRegex = new RegExp(/NOMBRE\n([A-Za-zÀ-ÖØ-öø-ÿ ]+\n){2}[A-Za-zÀ-ÖØ-öø-ÿ ]+/)

var addressString, namesString, mothersName, fathersName;

var schemaTempInfo = {}

export default function validate(fullText) {

    var schemaCustomerInfo = {}

    fullText.forEach(element => {
        if (element.match(dobRegex)) {
            var dobString = element.substring(element.search(dobRegex),).trim()
            schemaTempInfo.dobDay = dobString.substring(0, 2)
            if (schemaTempInfo.dobDay !== undefined) {
                schemaCustomerInfo.dobDay = schemaTempInfo.dobDay
            }
            schemaTempInfo.dobMonth = dobString.substring(3, 5)
            if (schemaTempInfo.dobMonth !== undefined) {
                schemaCustomerInfo.dobMonth = schemaTempInfo.dobMonth
            }
            schemaTempInfo.dobYear = dobString.substring(6, 10)
            if (schemaTempInfo.dobYear !== undefined) {
                schemaCustomerInfo.dobYear = schemaTempInfo.dobYear
            }
        }

        if (element.match(namesRegex)) {
            namesString = element.substring(element.indexOf('\n') + 1,)
            mothersName = namesString.substring(0, namesString.indexOf('\n') + 1)

            namesString = namesString.substring(namesString.indexOf('\n') + 1,).trim()
            fathersName = namesString.substring(0, namesString.indexOf('\n') + 1).trim()

            namesString = namesString.substring(namesString.indexOf('\n') + 1,)

            schemaTempInfo.lastName = mothersName.trim() + " " + fathersName.trim()
            if (schemaTempInfo.lastName !== undefined) {
                schemaCustomerInfo.lastName = schemaTempInfo.lastName
            }
            let indexOfLastLetterOfFirstName = namesString.indexOf('\n')
            if (indexOfLastLetterOfFirstName === -1) {
                var match = namesString.match(/[A-Za-zÀ-ÖØ-öø-ÿ ]/g);
                indexOfLastLetterOfFirstName = namesString.lastIndexOf(match[match.length - 1]);
            }
            schemaTempInfo.firstName = namesString.substring(0, indexOfLastLetterOfFirstName + 1).trim()
            if (schemaTempInfo.firstName !== undefined) {
                schemaCustomerInfo.firstName = schemaTempInfo.firstName
            }
        }

        if (element.match(addressRegex)) {
            addressString = element.substring(element.indexOf('DOMIC') + 10,)
            // sometimes the camera sees the space between the c and the rest of the first line of the address and sometimes not, we just want to get rid of it either way
                if (addressString.match(/^C /)) {
                    schemaTempInfo.address1 = addressString.substring(2, addressString.indexOf('\n')).trim()
                } else if (addressString.match(/^C/)) {
                    schemaTempInfo.address1 = addressString.substring(1, addressString.indexOf('\n')).trim()
                } else {
                    schemaTempInfo.address1 = addressString.substring(0, addressString.indexOf('\n')).trim()
                }
                if (schemaTempInfo.address1 !== undefined) {
                    schemaCustomerInfo.address1 = schemaTempInfo.address1
                }

            addressString = addressString.substring(addressString.indexOf('\n') + 1,)
            if (addressString.match(colonyRegex)) {
                schemaTempInfo.address2 = addressString.substring(4, addressString.search(zipcodeRegex)).trim()
                schemaTempInfo.postcode = addressString.substring(addressString.search(zipcodeRegex), addressString.indexOf('\n')).trim()
            }
            if (schemaTempInfo.address2 !== undefined) {
                schemaCustomerInfo.address2 = schemaTempInfo.address2
            }
            if (schemaTempInfo.postcode !== undefined) {
                schemaCustomerInfo.postcode = schemaTempInfo.postcode
            }

            addressString = addressString.substring(addressString.indexOf('\n') + 1,)

            if (addressString.includes(",")) {
                schemaTempInfo.city = addressString.substring(0, addressString.indexOf(",")).trim()
                let indexOfLastLetterOfCounty = addressString.indexOf('\n')
                if (indexOfLastLetterOfCounty === -1) {
                    var match = addressString.match(/[A-Za-zÀ-ÖØ-öø-ÿ. ]/g);
                    indexOfLastLetterOfCounty = addressString.lastIndexOf(match[match.length - 1]);
                }
                schemaTempInfo.county = addressString.substring(addressString.indexOf(",") + 1, indexOfLastLetterOfCounty + 1).trim()
            }
            if (schemaTempInfo.city !== undefined) {
                schemaCustomerInfo.city = schemaTempInfo.city
            }
            if (schemaTempInfo.county !== undefined) {
                schemaCustomerInfo.county = schemaTempInfo.county
            }
        }
    });

    return schemaCustomerInfo
}
